import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { NIGHT_SWITCH_TRANSLATION_KEY } from "../constants";
export default /*#__PURE__*/_defineProperty({}, NIGHT_SWITCH_TRANSLATION_KEY, {
  NIGHT_MODE: 'Night mode'
});